/**
 * Navigation - mobile menu toggle & keyboard accessibility
 */

import { gsap } from 'gsap';

class Navigation {
    constructor() {
        this.toggle = document.querySelector('.menu-toggle');
        this.menu = document.querySelector('#primary-menu');
        this.nav = document.querySelector('.main-navigation');
        this.header = document.querySelector('.site-header');

        if (this.toggle && this.menu) {
            this.init();
        }

        if (this.header) {
            this.initHeaderHide();
        }

        this.initDayyoLogoVisibility();
    }

    init() {
        this.toggle.addEventListener('click', () => this.toggleMenu());
        this.handleClickOutside();
        this.handleEscKey();
        this.handleResize();
    }

    initHeaderHide() {
        const header = this.header;
        const hideDistance = header.offsetTop + header.offsetHeight + 20;
        let lastY = window.scrollY;
        let hidden = false;
        const threshold = 8;

        const onScroll = () => {
            const y = window.scrollY;
            const delta = y - lastY;

            if (Math.abs(delta) < threshold) return;

            if (delta > 0 && y > 90 && !hidden) {
                hidden = true;
                gsap.to(header, {
                    y: -hideDistance,
                    duration: 0.45,
                    ease: 'power1.inOut',
                    overwrite: 'auto',
                });
            } else if (delta < 0 && hidden) {
                hidden = false;
                gsap.to(header, {
                    y: 0,
                    duration: 0.45,
                    ease: 'power1.inOut',
                    overwrite: 'auto',
                });
            }

            lastY = y;
        };

        window.addEventListener('scroll', onScroll, { passive: true });
    }

    initDayyoLogoVisibility() {
        const dayyoLogo = document.querySelector('.dayyo-logo');
        const siteBranding = document.querySelector('.site-branding');
        
        if (!dayyoLogo || !siteBranding) return;

        const checkVisibility = () => {
            const rect = dayyoLogo.getBoundingClientRect();
            const isInViewport = (
                rect.top < window.innerHeight &&
                rect.bottom > 0 &&
                rect.left < window.innerWidth &&
                rect.right > 0
            );

            gsap.to(siteBranding, {
                opacity: isInViewport ? 0 : 1,
                duration: 0.05,
                ease: 'none'
            });
        };

        // Check on scroll and resize
        window.addEventListener('scroll', checkVisibility, { passive: true });
        window.addEventListener('resize', checkVisibility, { passive: true });

        // Initial check on DOM loaded
        checkVisibility();
    }

    toggleMenu() {
        const isOpen = this.menu.classList.toggle('is-open');
        this.toggle.setAttribute('aria-expanded', String(isOpen));
    }

    closeMenu() {
        this.menu.classList.remove('is-open');
        this.toggle.setAttribute('aria-expanded', 'false');
    }

    handleClickOutside() {
        document.addEventListener('click', (e) => {
            if (this.nav && !this.nav.contains(e.target)) {
                this.closeMenu();
            }
        });
    }

    handleEscKey() {
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') {
                this.closeMenu();
                this.toggle.focus();
            }
        });
    }

    handleResize() {
        const mq = window.matchMedia('(min-width: 768px)');
        mq.addEventListener('change', (e) => {
            if (e.matches) {
                this.closeMenu();
            }
        });
    }
}

let navigation;

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
        navigation = new Navigation();
    });
} else {
    navigation = new Navigation();
}

export default navigation;
